import { render, staticRenderFns } from "./NflBestBetProp.vue?vue&type=template&id=3287f58e&scoped=true"
import script from "./NflBestBetProp.vue?vue&type=script&lang=js"
export * from "./NflBestBetProp.vue?vue&type=script&lang=js"
import style0 from "./NflBestBetProp.vue?vue&type=style&index=0&id=3287f58e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3287f58e",
  null
  
)

export default component.exports